const DIRECTION_TYPE = {
  departemental: "departemental",
  national: "national",
  regional: "regional",
};

module.exports = { DIRECTION_TYPE };
